import { FC, ReactNode, useEffect, useState } from 'react'
import { useDataLayer } from '~hooks'
import Context from './Context'

const isProd = process.env.NEXT_PUBLIC_API_HOST === 'https://granted.co/escher'

const EXPERIMENTS = isProd
  ? {
      sellingFastLabel: 'X7BU07oeSfeaQMhW_veBPQ',
    }
  : {
      sellingFastLabel: '_pHvW8HCSUSlcVTpdKibBQ',
    }

type ExperimentProps = {
  name: keyof typeof EXPERIMENTS
  loader?: ReactNode
  activateEvent?: 'optimize.activate' | 'optimize.activate1' | undefined | null
  activateCondition?: boolean
  children?: ReactNode
}

const Experiment: FC<ExperimentProps> = ({
  name,
  loader,
  children,
  activateEvent,
  activateCondition = true,
}) => {
  const id = EXPERIMENTS[name]
  const dl = useDataLayer()
  const [variant, setVariant] = useState('0')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (activateEvent && activateCondition) {
      dl.push({ event: activateEvent })
    }
  }, [activateEvent, activateCondition])

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.google_optimize !== undefined) {
        setVariant(window.google_optimize.get(id))
        setLoading(false)
        clearInterval(intervalId)
      }
    }, 100)
    return () => {
      clearInterval(intervalId)
      setLoading(false)
    }
  })

  if (loading) return <>{loader}</>

  return <Context.Provider value={variant}>{children}</Context.Provider>
}

export default Experiment
